import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import { css, cx } from 'emotion';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const carot = css`
  transition: transform 200ms;
  transform: rotate(-90deg);
  &.is-open {
    transform: rotate(0);
  }
`;

export function ActiveCarot({ isActive, isOpen }) {
  return isActive ? (
    <Check className="check" />
  ) : (
    // <Carot className={cx(carot, isOpen && 'is-open')} />
    <FontAwesomeIcon
      icon={['fas', 'sort-down']}
      className={cx(isOpen && 'is-open')}
    />
  );
}
